module.exports = __webpack_public_path__ + "app/principal/principal-offreApi-1xOzDYx5.html";